import request from '@/utils/request'

export default {
    getPayoutLogs: async({ dispatch, commit }, params) => {
        commit('payout/SET_LOAD', true, { root: true })
        await request({ method: 'get', url: 'withdraw-log', params: {
            ...Object.select(params, ['page', 'withdrawId', 'column', 'direction'])
        }})
            .then(res => {
                if (res.data && res.data.items) {
                    commit('SET_PAGINATION', {
                        length: res.data.totalPages,
                        page: res.data.page,
                        total: res.data.total
                    })
                    commit('SET_PAYOUT_LOGS', res.data.items)
                    commit('SET_LOAD', false)
                }
            })
    }
}
